import React from 'react';
import { connect } from 'react-redux';
import ButtonGroup from '../ButtonGroup';
import { shortCurrency } from '../../../utils/currency';
import styles from './button-group.module.scss';
import dictionary from '../../../dictionary';

function Effect(props) {
  const { name, content, onChange, current, vendorStyle, currency } = props;

  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        vendorStyle={vendorStyle}
        renderButton={({ value, translatedValue, difference }) => {
          return value === `glitter` ? (
            <span className={styles.value}>
              {translatedValue || dictionary.item.effect[value]}
              {` `}
              {value !== current && difference && (
                <span className={styles.difference}>
                  {difference > 0 && `+`}
                  {difference}
                  {shortCurrency(currency, difference)}
                </span>
              )}
            </span>
          ) : (
            <span className={styles.value}>
              {translatedValue || dictionary.item.effect[value]}
              {` `}
              {value !== current && difference && (
                <span className={styles.difference}>
                  {difference > 0 && `+`}
                  {difference}
                  {shortCurrency(currency, difference)}
                </span>
              )}
            </span>
          );
        }}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  currency: state.currency
});

export default connect(mapStateToProps)(Effect);
